import * as React from 'react';
import { usePopperTooltip } from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import {Fragment} from "react";

import './IconTooltip.scss' ;

const IconTooltip = ( props ) =>
{
    const {
        getArrowProps,
        getTooltipProps,
        setTooltipRef,
        setTriggerRef,
        visible
    } = usePopperTooltip( { placement: props.placement === undefined ? 'top' : props.placement, followCursor: true, offset: [0,8] }, { });

    const fontname = props.type === 'bootstrap' ? 'bi ' + props.icon : 'icon '+props.icon+ ' icon-fw icon-lg' ;

    return (
        <Fragment>
            { props.icon !== undefined && <span onClick={props.onClick} ref={setTriggerRef} style={{...props.style, cursor: 'pointer', color: props.color}} className={fontname} /> }
            { props.icon === undefined && <span ref={setTriggerRef}>{props.children}</span> }

            {visible && (
                <div
                    ref={setTooltipRef}
                    {...getTooltipProps({ className: 'tooltip-container' })}
                >
                    {props.text}
                    <div {...getArrowProps({ className: 'tooltip-arrow' })} />
                </div>
            )}
        </Fragment>
    );
}

export default IconTooltip ;
